// extracted by mini-css-extract-plugin
module.exports = {"content":"_kUhk-McT","heading":"_in5y2loK","subheading":"_uyoxzu_4"};